import React from 'react';
import cx from 'classnames';
import Col from '../GridSystem/Col';
import styles from './Card.module.scss';

function CardFooterSection(props) {
  const { className, children, ...rest } = props;
  return (
    <Col xs={4} className={cx(styles.footerSection, className)} {...rest}>
      {children}
    </Col>
  );
}

export default CardFooterSection;
